/* eslint-disable camelcase */
import { Logging } from "@newrelic/browser-agent/features/logging";
import { AgentOptions } from "@newrelic/browser-agent/loaders/agent";

const appId = "535916643";

const init = {
  distributed_tracing: { enabled: true },
  privacy: { cookies_enabled: true },
  ajax: { deny_list: ["bam.eu01.nr-data.net"] },
  logging: {
    enabled: true,
    autoStart: true,
  },
};

const info = {
  beacon: "bam.eu01.nr-data.net",
  errorBeacon: "bam.eu01.nr-data.net",
  licenseKey: "NRJS-10d5c72c1a14d608270",
  applicationID: appId,
  sa: 1,
};

const loader_config = {
  accountID: "2550020",
  trustKey: "2550020",
  agentID: appId,
  licenseKey: "NRJS-10d5c72c1a14d608270",
  applicationID: appId,
};

const config: AgentOptions = {
  init,
  info,
  loader_config,
  features: [Logging],
  exposed: true,
};

export default config;
